<!--suppress ALL -->
<template>
	<v-select :items="options" v-model="model" :label="label"></v-select>
</template>

<script>

	import MediaType from "root/packages/closeapp/QuestionsManager/assets/types/MediaType";

	export default {
		name: "media-type-select",
		props: {value: {default: null}, label: {default: "בחר סוג מדיה"}},
		computed: {
			options() {
				return MediaType.getAsOption();
			},
			model: {
				get() {
					return this.value;
				},
				set(val) {
					this.$emit("input", val);
				}
			}
		}
	};
</script>
